import "core-js/modules/es.array.push.js";
import { message } from 'ant-design-vue';
import axios from '../store/interface';
import { lang } from '@/locales';
// 找回密码
// import reqwest from 'reqwest'
// import axios from 'axios'

export default {
  name: 'index',
  data() {
    return {
      account: '',
      password: '',
      form: {
        account: '',
        password: '',
        code: ''
      },
      labelCol: {
        span: 7
      },
      wrapperCol: {
        span: 14
      },
      // 是否禁用按钮
      codeDisabled: false,
      // 倒计时秒数
      countdown: 60,
      // 按钮上的文字
      codeMsg: lang('get_ver_code')
    };
  },
  created() {
    console.log(process.env.VUE_APP_BASE_URL);
  },
  mounted() {
    // let _this = this;
    // document.onkeydown = function(e) {   //按下回车提交
    //     let key = window.event.keyCode;
    //     //事件中keycode=13为回车事件
    //     if (key == 13) {
    //         _this.goTo()
    //     }
    // };
  },
  methods: {
    goTo: function (event) {
      this.fetch({
        account: this.account,
        password: this.password
      });
    },
    goToLogin() {
      this.$router.push('/');
    },
    goToRegister() {
      this.$router.push('/register');
    },
    getCode() {
      if (this.timer) {
        return;
      }
      if (!this.form.account) {
        message.warning(lang('ph_phone_email'));
        return;
      }
      const promise = new Promise((resolve, reject) => {
        axios({
          method: 'get',
          url: process.env.VUE_APP_BASE_URL + 'manage/auth/forgetsendcode',
          params: {
            account: this.form.account
          }
        }).then(function (data) {
          resolve(data.data);
        });
      });
      promise.then(result => {});

      // reqwest({
      //   url: process.env.VUE_APP_BASE_URL + 'manage/auth/forgetsendcode',
      //   method: 'get',
      //   data: {
      //     account: this.form.account
      //   },
      //   type: 'json',
      //   crossOrigin: true
      // }).then(data => {

      // })
      // 验证码60秒倒计时
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.countdown > 0 && this.countdown <= 60) {
            this.countdown--;
            if (this.countdown !== 0) {
              this.codeMsg = `${lang('ph_phone_email')}(${this.countdown})`;
            } else {
              clearInterval(this.timer);
              this.codeMsg = lang('get_ver_code');
              this.countdown = 60;
              this.timer = null;
              this.codeDisabled = false;
            }
          }
        }, 1000);
      }
    },
    save() {
      // 错误校验
      if (!this.form.account) {
        message.warning(lang('ph_account'));
        return false;
      }
      if (!this.form.code) {
        message.warning(lang('ph_ver_code'));
        return false;
      }
      if (!this.form.password) {
        message.warning(lang('ph_pass'));
        return false;
      }
      this.fetch(this.form);
    },
    fetch(params = {}) {
      const _this = this;
      axios({
        method: 'post',
        url: process.env.VUE_APP_BASE_URL + 'manage/auth/resetpasswd',
        data: {
          ...params
        }
      }).then(function (data) {
        if (data.data.code == 200) {
          message.success(lang('tip_pass_success'));
          _this.$router.push('/login');
        } else {
          message.error(data.data.message);
        }
      });
    }
  },
  props: {
    msg: String
  }
};